module.exports = __webpack_public_path__ + "img/directions_car.6cff2709.svg";